import { Basket, BasketCosts, BasketItem } from 'entities/compilationContext/OnsiteCompilationContext/Basket';
import { IDiscount } from 'entities/compilationContext/discount';

export class SampleBasket implements Basket {
  public constructor({ currency, currencySymbol, costs, discount, items, repopulationURL, type }: Basket) {
    this.currency = currency;
    this.currencySymbol = currencySymbol;
    this.costs = costs;
    this.discount = discount;
    this.items = items;
    this.repopulationURL = repopulationURL;
    this.type = type;
  }

  public currency: string;
  public currencySymbol: string;
  public costs: BasketCosts;
  public discount: IDiscount;
  public items: BasketItem[];
  public repopulationURL: string;
  public type: string;
}
